<template>
  <div id="mainview">
    <el-main>
      <div
        id="container"
        @keydown="onKeyDown($event)"
        @keyup="onKeyUp($event)"
      ></div>
    </el-main>
    <Xiaoqu />
  </div>
</template>

<script>
import Event from './../lib/event.js'
import * as THREE from 'three/build/three.module'
import Xiaoqu from './xiaoqu.vue'

function loadJs(url, callback) {
  var script = document.createElement('script')
  script.type = 'text/javascript'
  if (typeof callback != 'undefined') {
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null
          callback()
        }
      }
    } else {
      script.onload = function() {
        callback()
      }
    }
  }
  script.src = url
  document.body.appendChild(script)
}

export default {
  name: 'MainView',
  components: {
    Xiaoqu
  },
  data() {
    return {
      desc: '3D View',
      O2: {},
      selObj: {},
      SCREEN_WIDTH: 800,
      SCREEN_HEIGHT: 600,
      btnDown: {
        x: 0,
        y: 0
      },
      mouse: {
        x: 0,
        y: 0
      },
      mouse_down: {
        x: 0,
        y: 0
      },
      list: [
        {
          name: '区位',
          icon: require('../assets/icon1.png'),
          active_icon: require('../assets/icon1_active.png')
        },
        {
          name: '漫游',
          icon: require('../assets/icon2.png'),
          active_icon: require('../assets/icon2_active.png')
        },
        // {
        //   name: "智能",
        //   icon: require("../assets/icon3.png"),
        //   active_icon: require("../assets/icon3_active.png"),
        // },
        {
          name: '户型',
          icon: require('../assets/icon4.png'),
          active_icon: require('../assets/icon4_active.png')
        }
      ]
    }
  },
  methods: {
    to(e) {
      console.log(e)
      this.$router.push({
        name: 'index'
      })
    },
    start3D() {
      ///////////////
      console.log('init scene')
      let o2world = []
      let container = document.getElementById('container')
      this.SCREEN_WIDTH = container.clientWidth
      this.SCREEN_HEIGHT = container.clientHeight
      let O2vr = this.O2vr
      O2vr.init(container)
      o2world.o2 = O2vr
      document.o2 = O2vr
      if (this.O2Builder) {
        let builder = this.O2Builder
        builder.init(O2vr)
        o2world.builder = builder
      }
      this.$parent.O2World = o2world
      document.o2 = O2vr
      O2vr.texLoader = new THREE.TextureLoader();
      // 4S店最新
      // let ppp = this.O2vr.load_zip_scene("http://o2res.oss-cn-beijing.aliyuncs.com/webres%2F%E6%A5%BC%E7%9B%98%2Fxiaoqu.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=1626621652&Signature=KZnZuFcdn0ZC98B38oBVzCd7V%2Fc%3D");
      //let ppp = this.O2vr.load_zip_scene("http://localhost/web/static/builder/dist/scene.zip");
      //let ppp = this.O2vr.load_zip_scene("http://o2res.oss-cn-beijing.aliyuncs.com/webres%2Fhome3d%2Fscene2.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=1662256386&Signature=2ee4RAY%2Fig4rLIdvzpViDZNplYE%3D");

      //let ppp = this.O2vr.load_o2_scene("http://192.168.1.69/web/static/builder/scene.json");
      let ppp = this.O2vr.load_zip_scene(
        "https://o2res.oss-cn-beijing.aliyuncs.com/dingzhou/%E5%AE%9A%E5%B7%9EWebgl.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001649412557&Signature=XoQ4SP8oEQ2SJlWmJlLwigi%2Fggo%3D"
      )

      let script_url = require('./script.js')
      loadJs(script_url, function() {
        console.log('script load done')
      })
      ppp.then(() => {
        console.log('load ended')
        Event.$emit('afterSceneOpened')
      })
    },
    onClick(event) {
      console.log('click')
      //this.O2Builder.onDocumentClick(event);
      if (this.O2vr.gizmo != undefined) {
        this.activeItem(this.O2vr.gizmo)
      }
    },
    onKeyDown(event) {
      //alert('keydown')
      if (event.ctrlKey && event.keyCode == 90) {
        //ctrl+z
        //alert('ctrl+z')
        //event.preventDefault();
        //console.log(this.$parent.O2Builder)
        //this.$parent.O2Builder.stack.canUndo() && this.$parent.O2Builder.stack.undo();
        //return false;
      }
      switch (event.key) {
        case 'q':
          {
            this.O2Builder.enable_gizmo(null)
          }
          break
        case 'w':
          {
            this.O2Builder.enable_gizmo(this.O2vr.selection)
            this.O2Builder.set_gizmo_mode('translate')
          }
          break
        case 'e':
          {
            this.O2Builder.enable_gizmo(this.O2vr.selection)
            this.O2Builder.set_gizmo_mode('rotate')
          }
          break
        case 'r':
          {
            this.O2Builder.enable_gizmo(this.O2vr.selection)
            this.O2Builder.set_gizmo_mode('scale')
          }
          break
        case 'g':
          {
            this.O2vr.reset_scene()
            let ppp = this.O2vr.load_o2_scene(
              './static/builder/dist/scene.json'
            )
            ppp.then(() => {
              console.log('load ended')
              Event.$emit('afterSceneOpened')
            })
          }
          break
        case 'z':
          {
            this.O2vr.reset_scene()
            let ppp = this.O2vr.load_zip_scene(
              './static/builder/dist/scene.zip'
            )
            ppp.then(() => {
              console.log('load ended')
              Event.$emit('afterSceneOpened')
            })
          }
          break
      }
    },
    onKeyUp(event) {
      //alert('keyup')
    },
    activeItem(tItem) {
      console.log('543')
      console.log(tItem)
      if (tItem instanceof Object && tItem.type == 'Mesh') {
        console.log('345')
        let obj = {}
        obj.type = tItem.type
        obj.name = 'tsel'
        obj.color = tItem.material.color
        obj.combineType = tItem.material.combine
        obj.reflectVal = tItem.material.reflectivity
        Event.$emit('selChanged', obj)
      }
    },
    setProp(propObj) {
      console.log(this.O2vr.gizmo)
      if (this.O2vr.gizmo.Object != undefined) {
        switch (this.O2vr.gizmo.Object.type) {
          case 'Mesh':
            {
              this.updateMesh(propObj)
            }
            break
          case 'Light':
            {
            }
            break
        }
      }
    },
    updateMesh(obj) {
      console.log('updatemesh')
      let mesh = this.O2vr.gizmo.Object
      if (mesh === undefined || mesh === null) {
        return
      }
      switch (obj.idx) {
        case '202101':
          {
            console.log(obj.val)
            if (obj.val == 2) {
              mesh.material.combine = THREE.AddOperation
            } else if (obj.val == 1) {
              mesh.material.combine = THREE.MixOperation
            } else {
              mesh.material.combine = THREE.MultiplyOperation
            }
            //this.selObj.material.combine = parseInt(obj.val);
            mesh.material.needsUpdate = 1
          }
          break
        case '202102':
          {
            console.log(obj.val)
            mesh.material.reflectivity = obj.val
          }
          break
        case '202103':
          {
          }
          break
        case '202104':
          {
          }
          break
      }
    }
  },
  created() {},
  mounted() {
    //在模板编译完成后执行
    document.addEventListener('keydown', this.onKeyDown, false)
    document.addEventListener('keyup', this.onKeyUp, false)
    this.start3D()

    Event.$on('toolsChanged', (idx) => {
      //箭头函数内部不会产生新的this，这边如果不用=>,this指代Event
      //console.log(Event)
      //alert('监听到消息:'+idx)
      console.log('ToolBar message')
      console.log(idx)
      switch (idx) {
        case '1':
          {
          }
          break
        case '2':
          {
          }
          break
        case '3':
          {
          }
          break
        case '4':
          {
            this.O2vr.set_gizmo_mode('translate')
          }
          break
        case '5':
          {
            this.O2vr.set_gizmo_mode('rotate')
          }
          break
        case '6':
          {
            this.O2vr.set_gizmo_mode('scale')
          }
          break
        default:
          {
            alert(idx)
            alert('default')
          }
          break
      }
    })

    Event.$on('propsChanged', (obj) => {
      //箭头函数内部不会产生新的this，这边如果不用=>,this指代Event
      //console.log(Event)
      //alert('监听到消息:'+idx)
      console.log('Prop message')
      console.log(obj)
      this.setProp(obj)
    })
  }
}
</script>

<style lang="scss" scoped>
#mainview,
#container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.el-main {
  padding: 0 !important;
  background-color: #e9eef3;
  color: #333;
  height: 100%;
}

.index {
  width: 100%;
  height: 100%;
  text-align: center;
  overflow: hidden;
  .list {
    width: 100%;
    height: 65px;
    display: flex;
    justify-content: space-around;
    background: transparent;
    bottom: 0;
    position: fixed;
    align-items: center;
  }
  .box {
    p {
      font-size: 10px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      line-height: 18px;
      color: #999;
    }
    .active {
      color: #ffbc1e;
    }
  }
}
</style>
